/** @format */

import React, { Component } from 'react';
import { Container, Grid, Form, Icon } from 'semantic-ui-react';
import database from '../../firebase/config';
import { inject, observer } from 'mobx-react';

@inject('UserStore')
@observer
class Board extends Component {
  state = {
    bugForm: {
      argument: '',
      text: '',
      userFullName: '',
    },
  };

  bugReportInput = (name, value) => {
    let bugForm = { ...this.state.bugForm };
    bugForm[name] = value;
    this.setState({ bugForm });
  };

  reportBug = () => {
    let { UserStore } = this.props;
    let bugRef = database.ref('/bugs');
    let bug = { ...this.state.bugForm };
    bug.userFullName = UserStore.userFullName;
    bugRef.push(bug).then(() => {
      this.setState({
        bugForm: {
          argument: '',
          text: '',
          userFullName: '',
        },
      });
    });
  };

  render() {
    return (
      <div>
        <Container className="content-container">
          <Grid>
            <Grid.Column tablet={16} computer={8}>
              <h2>CRM Autoricambi.it 0.6Beta</h2>
              <br />
              <h3>Ultimi Update</h3>
              <p>- Sistema di registro comunicazioni</p>
              <p>- Informazioni generali Richiesta</p>
              <p>- Esplicitazione disponibilità ricambi nella richiesta</p>
            </Grid.Column>
            <Grid.Column tablet={16} computer={8}>
              <h3>Segnalazione Bug</h3>
              <br />
              <p>
                Si prega di segnalare qualsiasi bug o anomalia descrivendo il
                più precisamente possibile le azioni che hanno portato al
                verificarsi del problema. Utilizza il modulo sottostante per
                segnalare.
              </p>
              <Form
                onSubmit={() => {
                  this.reportBug();
                }}
              >
                <Form.Select
                  onChange={(e, selection) => {
                    this.bugReportInput(selection.name, selection.value);
                  }}
                  name="argument"
                  options={[
                    {
                      text: 'Gestione delle richieste',
                      value: 'Gestione delle richieste',
                    },
                    {
                      text: 'Gestione delle vendite',
                      value: 'Gestione delle vendite',
                    },
                    {
                      text: 'Gestione dei clienti',
                      value: 'Gestione delle clienti',
                    },
                  ]}
                  value={this.state.bugForm.argument}
                  label="Sezione o argomento"
                  placeholder="Argomento"
                />
                <Form.TextArea
                  label="descrizione bug"
                  placeholder="Descrivi qui l'anomalia riscontrata"
                  name="text"
                  value={this.state.bugForm.text}
                  onChange={e => {
                    this.bugReportInput(e.target.name, e.target.value);
                  }}
                />
                <Form.Button type="submit" color="green" fluid>
                  <Icon name="bug" /> Segnala Bug
                </Form.Button>
              </Form>
            </Grid.Column>
          </Grid>
        </Container>
      </div>
    );
  }
}

export default Board;
